<template>
  <div id="output"></div>
</template>

<script>
export default {
  name: "Button",
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  mounted() {
    document.getElementById("output").innerHTML = this.data.fileContent;
  },
  watch: {
    'data.fileContent'(val) {
      document.getElementById("output").innerHTML = val;
    }
  },
}
</script>

<style>
.center {
  text-align: center;
}
</style>